import Splide from '@splidejs/splide';

export class Gallery {
  constructor(){
    this.ELS = document.querySelectorAll('.js-gallery');
  }

  mountAll = () => {
    this.ELS.forEach((EL) => {
      const tab_hidden = EL.closest('.js-tabs-list__item[hidden]')

      if(!tab_hidden){
        this.mount(EL)
      }
    });
  }

  mount = (el) => {
    new Splide( el, {
      type: "slide",
      arrows: false,
      pagination: true,
      autoWidth: true,
      perPage: 2,
      gap: 60,
      padding: {
        right: 150
      },
      breakpoints: {
        1024: {
          gap: 30,
          padding: {
            left: 50,
            right: 250
          },
        },
      },
    } ).mount();
  }
}

const galleryobject = new Gallery()
galleryobject.mountAll();
